import type { AxiosInstance } from 'axios';

import { api, setAuthorizationToken } from './axios/axios';
import { createErrorNormalizerInterceptor } from './axios/error-interceptor';
import { graphql as graphqlAxios } from './axios/graphql';
import {
  addRequestInterceptor,
  addResponseInterceptor,
  type RequestInterceptorHandler,
  type ResponseErrorHandler,
} from './axios/interceptors';
import type { IHttpClientContainer } from './types/http-client.interface';

// Normalizador registrado ao carregar o módulo = sempre primeiro na cadeia de erro.
// Garante que qualquer handler registrado depois receba sempre ApiRequestError.
addResponseInterceptor(createErrorNormalizerInterceptor());

export const httpClient: IHttpClientContainer<
  AxiosInstance,
  RequestInterceptorHandler,
  ResponseErrorHandler
> = {
  api,
  graphql: graphqlAxios,
  interceptors: {
    request: {
      use: addRequestInterceptor,
    },
    response: {
      use: addResponseInterceptor,
    },
  },
  auth: {
    setToken: setAuthorizationToken,
  },
  errorNormalizer: createErrorNormalizerInterceptor,
};
